import Transfers from './Transfers';

export enum CMItemCode {
	CM_ENABLED = 'CM_ENABLED',
	CM_SKILLMAP_ENABLED = 'CM_SKILLMAP_ENABLED',
}

// システムマスタデータ検索処理
export const fetchCMData = (token: string) => {
	const param = {};
	Transfers.read('com_skill_GetCMOptionValue', token, param)
		.then(response => response.json())
		.then(receiveData => receiveData.com_skill_GetCMOptionValue)
		.then(data => {
			if (data) {
				localStorage.setItem('CM_ENABLED', data);
			}
		})
		.catch(e => {
			return;
		});
	Transfers.read('com_skill_GetCMSkillMapDisplayValue', token, param)
		.then(response => response.json())
		.then(receiveData => receiveData.com_skill_GetCMSkillMapDisplayValue)
		.then(data => {
			if (data) {
				localStorage.setItem('CM_SKILLMAP_ENABLED', data);
			}
		})
		.catch(e => {
			return;
		});
};

export const getCMData = (cmItemCode: CMItemCode): string | null => {
	return localStorage[cmItemCode];
};

export const isValid = (cmItemCode: CMItemCode): boolean => {
	const value = localStorage[cmItemCode];
	return value && value === 'Y' ? true : false;
};



// WEBPACK FOOTER //
// ./src/utils/CMData.ts